var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_c('img',{staticClass:"back",attrs:{"src":require("../../assets/icon/back.png")},on:{"click":_vm.back}}),_c('p',[_vm._v(_vm._s(_vm.title))]),_c('a',{attrs:{"href":_vm.url,"target":"blank"}},[_c('img',{attrs:{"src":require("../../assets/icon/下载icon.png")}})])]),_c('div',{attrs:{"id":"pdf"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }